import styled from 'styled-components';

export const ItemContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: 9px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows[1]};
  ${(props) => props.theme.breakpoints.down('sm')} {
    margin-top: 5px;
    border-radius: 0;
    h4 {
      padding-left: 16px;
    }
  }
`;

export const TitleContainer = styled.h4`
  ${(props) => props.theme.breakpoints.down('sm')} {
    padding-left: 16px;
    margin-bottom: 2px;
    margin-top: 30px;
  }
`;

export const SubtitleContainer = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  margin: 0;
  padding-bottom: 10px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    color: ${({ theme }) => theme.palette.text.primary};
    padding-left: 16px;
    margin-bottom: 2px;
  }
`;
